import { PrescriptionHistoryPrescription } from '@dreryk/egabinet-prescription-frontend-api';

import { IconWrapper, QuestionmarkCircleIcon, Text, Tooltip, TooltipLabel } from '@dreryk/react-components';

import { ExtendedDosageStagesList, useFormatStages } from '~libs.desktop.shared.medicine';
import { formatPreciseDosage } from '~libs.shared.prescription';

import { translationKeys } from '../../translations';

import { StyledPrescriptionHistoryDosageCell } from './PrescriptionHistoryDosageCell.styled';

type PrescriptionHistoryDosageCellProps = {
   readonly prescription: PrescriptionHistoryPrescription;
};

type ExtendedPrescriptionHistoryDosageCellProps = {
   readonly extendedDosage: NonNullable<PrescriptionHistoryPrescription['extendedDosage']>;
   readonly dosage: PrescriptionHistoryPrescription['dosage'];
};

const DOSAGE_MAX_LINES = 2;

const ExtendedPrescriptionHistoryDosageCell = (props: ExtendedPrescriptionHistoryDosageCellProps): JSX.Element => {
   const formatStages = useFormatStages();

   return (
      <StyledPrescriptionHistoryDosageCell alignItems={'flex-end'} gap={'4px'}>
         <Text testId={'dosage'} maxLines={DOSAGE_MAX_LINES}>
            {[...formatStages(props.extendedDosage.stages, props.extendedDosage.portionUnit), props.dosage]
               .filter(Boolean)
               .join(', ')}
         </Text>
         <Tooltip
            testId={'extendedDosageTooltip'}
            content={() => (
               <div>
                  <TooltipLabel label={translationKeys.table.extendedDosageTooltipTitle} />
                  <ExtendedDosageStagesList
                     stages={props.extendedDosage.stages}
                     portionUnit={props.extendedDosage.portionUnit}
                  />
               </div>
            )}
         >
            <IconWrapper testId={'extendedDosageIcon'}>
               <QuestionmarkCircleIcon />
            </IconWrapper>
         </Tooltip>
      </StyledPrescriptionHistoryDosageCell>
   );
};

export const PrescriptionHistoryDosageCell = (props: PrescriptionHistoryDosageCellProps): JSX.Element => {
   const { extendedDosage, preciseDosage, dosage } = props.prescription;

   if (!extendedDosage || !extendedDosage.stages.length) {
      return (
         <Text testId={'dosage'}>
            {[preciseDosage ? formatPreciseDosage(preciseDosage) : null, dosage].filter(Boolean).join(', ')}
         </Text>
      );
   }

   return <ExtendedPrescriptionHistoryDosageCell extendedDosage={extendedDosage} dosage={dosage} />;
};
